import { isClient, watchImmediate, useLocalStorage } from '@vueuse/core'

const COOKIE_NAME = 'active_theme'
const DEFAULT_THEME = 'blue'

export function useThemeConfig() {
  const activeTheme = useLocalStorage<string>(COOKIE_NAME, DEFAULT_THEME)

  watchImmediate(activeTheme, () => {
    if (!isClient) return

    Array.from(document.body.classList)
      .filter((className) => className.startsWith('theme-'))
      .forEach((className) => {
        document.body.classList.remove(className)
      })
    document.body.classList.add(`theme-${activeTheme.value}`)
    if (activeTheme.value.endsWith('-scaled')) {
      document.body.classList.add('theme-scaled')
    }
  })

  return {
    activeTheme
  }
}
